//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import MaterialInput from "../inputs/material-input.vue";
import PasswordInput from "../inputs/password-input.vue";
import { emailCaseInsensitive } from "@Shared/@Utils/validation-rules";
import TermsLinks from "./terms-links.vue";
import { isProduction } from "@Shared/@Utils/helpers/settings";
import { MAIN_API } from "@Shared/@Utils/constants";
import { getPublicApi } from "@Shared/utils/ajax";
import MfaContainer from "@Shared/components/general/mfa-container.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "LoginPage",
  components: {
    MaterialInput,
    SimpleButton,
    PasswordInput,
    TermsLinks,
    MfaContainer
  },
  mixins: [validationMixin],
  validations: {
    email: {
      required,
      emailCaseInsensitive
    },
    password: {
      required
    }
  },
  props: {
    portal: {
      type: String,
      default: ""
    },
    logo: {
      type: String,
      default: ""
    },
    mfaEmail: {
      type: String,
      default: ""
    },
    prefilledEmail: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadingStatus: {
      type: Boolean,
      default: true
    },
    sendingMfaCode: {
      type: Boolean,
      default: false
    },
    mfaCodeDelivered: {
      type: Boolean,
      default: true
    },
    isMfaRequiredAndNotEnabled: {
      type: Boolean,
      default: false
    },
    validateMfaCode: {
      type: Boolean,
      default: false
    },
    codeDestination: {
      type: String,
      default: ""
    },
    mfaPreferences: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      email: this.prefilledEmail,
      password: "",
      isProduction,
      table: {
        fields: ["repo", "name", "branch"]
      }
    };
  },
  computed: {
    valid() {
      return !this.$v.$invalid;
    },
    isClient() {
      return this.portal === "client";
    }
  },
  methods: {
    handleSubmit() {
      if (!this.valid) return;
      this.$emit("submit", {
        email: this.email,
        password: this.password
      });
    },
    async tableData() {
      return isProduction ? [] : await getPublicApi({}, `${MAIN_API}/brokers/get-build-status`);
    },
    enableMfa({
      mfaValue,
      method
    }) {
      this.$emit("enableMfa", {
        mfaValue,
        method
      });
    },
    validateMfaAndSignIn(value) {
      this.$emit("validateMfaAndSignIn", {
        mfaCode: value.mfaCode,
        isTrustedDevice: value.isTrustedDevice
      });
    },
    snoozeMfaSetup() {
      this.$emit("snoozeMfaSetup");
    },
    reSendCode() {
      this.$emit("reSendCode");
    }
  }
});